import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { Text, View, Page, Link } from '@react-pdf/renderer';

import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { styles } from './styles';
import { SafeImage } from '../../components/SafeImage';
import { SPONSOR_EMAIL } from '@utils/constants';

interface PartnersAndExhibitorsDefaultPageProps {
  event: PublicEventDetailsResponse;
  header: JSX.Element;
  footer: JSX.Element;
}

const PartnersAndExhibitorsDefaultPage = ({
  event,
  header,
  footer,
}: PartnersAndExhibitorsDefaultPageProps) => {
  const { t } = useTranslation();

  const sponsorSubject = t('sponsorMailto.subject', { eventName: event?.name });
  const sponsorBody = t('sponsorMailto.body', { eventName: event?.name });
  const sponsorMailHref = `mailto:${SPONSOR_EMAIL}?subject=${encodeURIComponent(sponsorSubject)}&body=${encodeURIComponent(sponsorBody)}`;

  return (
    <Page style={styles.page}>
      {header}

      <View style={styles.contentWrapper}>
        <Text style={{ ...styles.title, color: event?.design?.themeColor }}>
          {t('partner-&-exhibitors')}
        </Text>

        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? 'black',
            marginLeft: 0,
            marginBottom: 20,
            width: 89,
          }}
        />

        <Text style={styles.description}>
          {t('partner-&-exhibitors-text', {
            year: new Date(event?.start_date ?? '').getFullYear(),
            eventNameWithoutYear: event?.name.replace(/\s\d{4}/, ''),
          })}
        </Text>

        <View
          style={{
            ...styles.buttonWrapper,
            backgroundColor: event?.design?.themeColor ?? 'black',
            color: 'white',
          }}
        >
          <Link href={sponsorMailHref} style={styles.linkText}>
            {t('apply-as-partner')}
          </Link>
        </View>

        <View style={{ flexDirection: 'column', width: '100%' }}>
          <SafeImage
            style={styles.topImage}
            src="https://media.we-conect.com/images/pdf/agenda/partners_exhibitors_1.jpg"
            debugLabel="partners-exhibitors-1"
          />

          <View style={styles.imageRow}>
            <SafeImage
              style={styles.thumbnail}
              src="https://media.we-conect.com/images/pdf/agenda/partners_exhibitors_2.jpg"
              debugLabel="partners-exhibitors-2"
            />

            <SafeImage
              style={styles.thumbnail}
              src="https://media.we-conect.com/images/pdf/agenda/partners_exhibitors_3.png"
              debugLabel="partners-exhibitors-3"
            />

            <SafeImage
              style={styles.thumbnail}
              src="https://media.we-conect.com/images/pdf/agenda/partners_exhibitors_4.png"
              debugLabel="partners-exhibitors-4"
            />
          </View>
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default PartnersAndExhibitorsDefaultPage;
